import React from "react";
import { useTranslation } from "react-i18next";

import useGetUrlLocale from "../../hooks/useGetUrlLocale";

import NotificationsDropdown from "./notificationsDropdown";

export default function Heading() {
  const { t } = useTranslation();
  const locale = useGetUrlLocale();

  return (
    <div className="col-12 d-flex align-items-center justify-content-end mb-3">
      <a
        target="_blank"
        href={
          process.env.REACT_APP_TICKET_URL + locale + "/organizer-support-chat"
        }
        rel="noopener noreferrer"
        className="text-success fs-8 me-3 text-decoration-none"
      >
        {t("menu.support")}
      </a>
      <NotificationsDropdown />
    </div>
  );
}
